import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LoggableObservable } from '../../core/decorators/LoggableObservable';
import { AppConfig } from 'src/app/app-config';

@Injectable({
  providedIn: 'root',
})
export class RestService {
  // TODO IMPROVEMENT: Use of enviroment file to config base url
  baseUrl: string;

  public BUILD_HTTP_ROUTE = (url, ...args) => `${url}/${args.join('/')}`;

  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfig,
  ) {
    this.baseUrl = `${this.appConfig.cmsApiBaseUrl}/`;
  }

  @LoggableObservable()
  get$<T>(url: string, options = {}): Observable<T> {
    return this.httpClient.get<T>(`${this.baseUrl}${url}`, options);
  }

  @LoggableObservable()
  head$<T>(url: string, options = {}): Observable<T> {
    return this.httpClient.head<T>(`${this.baseUrl}${url}`, options);
  }

  @LoggableObservable()
  getCustom$(url: string, options = {}): Observable<object> {
    return this.httpClient.get(url, options);
  }

  @LoggableObservable()
  post$<T>(url: string, data: any, options = {}): Observable<T> {
    return this.httpClient.post<T>(`${this.baseUrl}${url}`, data, options);
  }

  @LoggableObservable()
  postCustom$(url: string, data: any, options = {}): Observable<object> {
    return this.httpClient.post(url, data, options);
  }

  @LoggableObservable()
  put$<T>(url: string, data: any, options = {}): Observable<T> {
    return this.httpClient.put<T>(`${this.baseUrl}${url}`, data, options);
  }

  @LoggableObservable()
  putCustom$(url: string, data: any, options = {}): Observable<object> {
    return this.httpClient.put(url, data, options);
  }

  @LoggableObservable()
  remove$(url: string, options = {}): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}${url}`, options);
  }

  @LoggableObservable()
  patch$<T>(url: string, data: any, options = {}): Observable<T> {
    return this.httpClient.patch<T>(`${this.baseUrl}${url}`, data, options);
  }

  @LoggableObservable()
  patchCustom$(url: string, data: any, options = {}): Observable<object> {
    return this.httpClient.patch(url, data, options);
  }

  @LoggableObservable()
  requestCustom$(request: HttpRequest<any>): Observable<any> {
    return this.httpClient.request(request);
  }

  public buildHttpParamsObject(params: {}): HttpParams {
    let paramsObject = new HttpParams();
    const paramsKeys = Object.keys(params);
    paramsKeys.forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) {
        paramsObject = paramsObject.append(key, value.toString());
      }
    });

    return paramsObject;
  }

  public buildParamsObjectWithPaging(
    params: {},
    pageNumber: number,
    pageSize: number,
  ): HttpParams {
    let paramsObject = this.buildHttpParamsObject(params);
    paramsObject = this.addPagingParams(paramsObject, pageNumber, pageSize);
    return paramsObject;
  }

  private addPagingParams(
    httpParams: HttpParams,
    pageNumber: number,
    pageSize: number,
  ): HttpParams {
    httpParams = httpParams.append('pageNumber', pageNumber.toString());
    httpParams = httpParams.append('pageSize', pageSize.toString());
    return httpParams;
  }
}
